export const BILLING_CLIENT_EVENTS = [
  "billing_viewed", "billing_offer_clicked", "billing_checkout_requested", "billing_checkout_redirected", "billing_checkout_error",
] as const;
export type BillingClientEvent = typeof BILLING_CLIENT_EVENTS[number];

const SOURCES = ["pricing", "guardian", "story_bible", "credits", "usage_indicator", "billing", "direct", "copilot", "dashboard", "project_limit", "quota", "reengagement", "editor_marketing"];
const STAGES = ["load", "checkout"];

/** Purchase analytics contain only fixed categories, never URLs, prose or errors. */
export function billingEventData(value: Record<string, unknown> = {}) {
  return {
    source: typeof value.source === "string" && SOURCES.includes(value.source) ? value.source : "direct",
    offer: value.offer === "writer" || value.offer === "pack" ? value.offer : "none",
    ...(typeof value.stage === "string" && STAGES.includes(value.stage) ? { stage: value.stage } : {}),
  };
}
